/**
 * @file main.module.ts
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { MaterialModule } from '@core/modules';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { SHARED_COMPONENTS } from '@shared/components';
import { SetImagePathDirective } from "@shared/directives";

@NgModule({
  declarations: [MainComponent, UpdateProfileComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SHARED_COMPONENTS,
    SetImagePathDirective
]
})
export class MainModule { }
